import * as React from "react";
import { Spinner } from "@skbkontur/react-ui";
import { KonturColors } from "@skbkontur/colors";

export const Preloader = () => <Spinner type={"mini"} caption={"Загрузка..."} color={KonturColors.grayscaleText} />;
